import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "VehicleOutTypeListPage" */
	'pages/vehicle/VehicleOutType/VehicleOutTypeListPage'));

export default [{ component, exact: true, path: '/vehicle_out_types' }];